import styled, { css } from 'styled-components';
import DoubleArrowSrc from 'assets/images/double-arrow-right.svg';

import { colours, common } from 'themes/default';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const AuditInfo = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  > *:not(:last-child) {
    margin: 0 10px 0 0;
  }
`;

export const ActionType = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: bold;
`;

export const ActionContent = styled.div`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  font-weight: bold;
  height: 0;
  padding: 0 10px 0 10px;
  overflow: hidden;

  ${(props) =>
    props.isExpanded &&
    css`
      height: ${(p) => (p.height ? p.height : 'auto')};
      overflow: scroll;
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;
export const HistoryWrapper = styled.div`
  width: min-content;
  padding: 10px;

  > *:not(:first-child) {
    margin: 15px 0 0 0;
  }
`;

export const ActionWrapper = styled.div`
  font-weight: bold;
`;

export const ActionItemCustomer = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(2, min-content) auto;
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemCustomerCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: nowrap;
`;

export const ActionItemNote = styled.div`
  display: flex;
  flex: 1;
  background-color: white;
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemNoteCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: wrap;
`;

export const ActionItemPassenger = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(2, min-content) auto;
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemPassengerCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: nowrap;
`;

export const ActionItemPayment = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: min-content auto;
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemPaymentCell = styled.div`
  align-items: center;
  display: flex;
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: nowrap;

  ${({ isDiscountCode }) =>
    isDiscountCode &&
    css`
      padding: 0;
    `}
`;

export const ActionItemPaymentMethodCell = styled.div`
  flex: 1;
  padding: 5px 20px;
  border-left: 1px solid ${colours.Greyscale.SilverGrey};

  :first-child {
    border-left: none;
  }
`;

export const ActionItemPointsCell = styled.div`
  flex: 1;
  margin-left: 20px;
  padding: 5px 20px;
  border-left: 1px solid ${colours.Greyscale.SilverGrey};
`;

export const ActionItemTicket = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(3, min-content) auto;
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemTicketCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: nowrap;
`;

export const ActionItemBookingItems = styled.div`
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(7, minmax(min-content, auto));
  font-weight: normal;
  margin: 15px 0 0 0;
`;

export const ActionItemFullRow = styled.div`
  grid-column: 1 / -1;
  margin: 8px 0;
`;

export const ActionItemSegmentHeader = styled.div`
  grid-column-start: 1;
  grid-column-end: 8;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(min-content, auto);
  background-color: ${colours.Core.SecondaryPlum};
  border: 1px solid ${colours.Core.SecondaryPlum};
  grid-gap: 1px;
`;

export const ActionItemSegmentHeaderCell = styled.div`
  background-color: ${colours.Shades.TintBlue10};
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: bold;
  padding: 5px;
  white-space: nowrap;
`;

export const ActionItemSegmentContent = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(min-content, auto));
  grid-column-gap: 20px;
  grid-row-gap: 5px;
`;

export const ActionItemSegmentContentCell = styled.div`
  background-color: white;
  padding: 5px;
  white-space: nowrap;
`;

export const ActionItemSegmentContentCellHighlight = styled.div`
  display: grid;
  grid-column: 1 / -1;
  background-color: rgba(255, 230, 0, 0.2);
  border-radius: 50px;
  margin: 10px 0;
  padding: 5px 10px;
  white-space: nowrap;
`;

export const ActionItemSegmentHotelCell = styled.div`
  background-color: white;
  padding: 5px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: underline;
`;

export const ActionHeader = styled.div`
  background-color: ${common.bigAccordionButtons.backgroundColour};
  color: ${common.bigAccordionButtons.fontColour};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const HeaderToggleWrapper = styled.div`
  width: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 0;
`;

export const HeaderToggle = styled.img`
  width: 12px;
  height: 12px;
  transition: all 0.4s ease-in-out;

  ${(props) =>
    props.isExpanded &&
    css`
      transform: rotate(90deg);
    `}
`;

HeaderToggle.defaultProps = {
  src: DoubleArrowSrc
};

export const ActionsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
`;
